import { graphql } from '../__generated__/gql';

export const GET_CERTIFICATE_TYPE_ENUM = graphql(/* GraphQL */ `
  query CertificateTypeEnum {
    certificateTypeEnum {
      key
      value
    }
  }
`);

export const GET_ALL_CERTIFICATES = graphql(/* GraphQL */ `
  query Certificates($assetId: Int!) {
    allCertificates(assetId: $assetId) {
      certificateId
      title
      assetId
      certificateNumber
      type
      template
      status
      maintenanceOrder
      permitNumber
      lubricantUsed
      location
      system
      area
      isolationNumber
      createdBy
      checkedBy
      createdAt
      updatedAt
      functionalLocation
      comments

      maintenanceMC1 {
        mc1Id
        mc1Number
        assetId
      }

      maintenanceSH1 {
        sh1Id
        sh1Number
        assetId
      }
    }
  }
`);

export const GET_ALL_CERTIFICATES_WITH_JOINT_DETAILS = graphql(/* GraphQL */ `
  query CertificatesWithJointDetails($assetId: Int!) {
    allCertificates(assetId: $assetId) {
      certificateId
      title
      assetId
      certificateNumber
      type
      template
      status
      maintenanceOrder
      permitNumber
      lubricantUsed
      location
      system
      area
      isolationNumber
      createdBy
      checkedBy
      createdAt
      updatedAt
      functionalLocation
      comments

      maintenanceMC1 {
        mc1Id
        mc1Number
        assetId
        mediaUrl
        fileName
        mime
      }

      maintenanceSH1 {
        sh1Id
        sh1Number
        assetId
        mediaUrl
        fileName
        mime
      }

      tarJoints {
        jointId
        jointNumber
        additionalDetails
        certificateId
        tagId
        supervisedAssembly

        tarJointInstallationSteps {
          stepId
          jointId
          stepNo
          stepTitle
          signedAt
          signedBy
          createdAt
          updatedAt
        }
      }
    }
  }
`);

export const GET_CERTIFICATE_DETAILS = graphql(/* GraphQL */ `
  query CertificateDetails($certificateId: Int!) {
    certificateDetails(certificateId: $certificateId) {
      certificateId
      title
      assetId
      certificateNumber
      type
      template
      status
      maintenanceOrder
      permitNumber
      lubricantUsed
      location
      system
      area
      isolationNumber
      createdBy
      checkedBy
      createdAt
      updatedAt
      functionalLocation
      comments

      maintenanceMC1 {
        mc1Id
        mc1Number
        assetId
        mediaUrl
        fileName
        mime
      }

      maintenanceSH1 {
        sh1Id
        sh1Number
        assetId
        mediaUrl
        fileName
        mime
      }

      tarJoints {
        jointId
        certificateId
        jointNumber
        additionalDetails
        tagId
        pIdNo
        flangeSize
        rating
        supervisedAssembly
        boltDiameter
        boltQuantity
        boltLength
        boltMaterial
        gasketType
        torqueValue
        hydraulicToolRef
        hydraulicToolPass
        hydraulicToolPumpPressure
        createdBy
        updatedBy
        createdAt
        updatedAt

        tarJointInstallationSteps {
          stepId
          jointId
          stepNo
          stepTitle
          signedAt
          signedBy
        }
      }
    }
  }
`);

export const CREATE_CERTIFICATE = graphql(/* GraphQL */ `
  mutation CreateCertificate($input: CertificateInput!) {
    createCertificate(input: $input) {
      certificateId
    }
  }
`);

export const UPDATE_CERTIFICATE = graphql(/* GraphQL */ `
  mutation UpdateCertificate($input: CertificateInput!) {
    updateCertificate(input: $input) {
      certificateId
    }
  }
`);

export const REMOVE_CERTIFICATE = graphql(/* GraphQL */ `
  mutation RemoveCertificate($certificateId: Int!) {
    removeCertificate(certificateId: $certificateId)
  }
`);

export const DUPLICATE_CERTIFICATE = graphql(/* GraphQL */ `
  mutation DuplicateCertificate($certificateId: Int!) {
    duplicateCertificate(certificateId: $certificateId) {
      certificateId
    }
  }
`);

export const CERTIFICATE_ATTACHMENTS = graphql(/* GraphQL */ `
  query CertificateAttachments($certificateId: Int!) {
    attachmentsByCertificateId(certificateId: $certificateId) {
      certificateId
      attachmentId
      fileName
      attachmentUrl
      mime
    }
  }
`);

export const REMOVE_CERTIFICATE_ATTACHMENT = graphql(/* GraphQL */ `
  mutation RemoveCertificatAttachment($attachmentId: Int!) {
    removeAttachment(attachmentId: $attachmentId)
  }
`);

export const CREATE_ATTACHMENT = graphql(/* GraphQL */ `
  mutation CreateAttachment($input: AttachmentInput!) {
    createAttachment(input: $input) {
      attachmentId
    }
  }
`);

export const UPDATE_MC1 = graphql(/* GraphQL */ `
  mutation UpdateMC1($input: MC1Input!) {
    updateMC1(input: $input) {
      mc1Id
    }
  }
`);

export const UPDATE_SH1 = graphql(/* GraphQL */ `
  mutation UpdateSH1($input: SH1Input!) {
    updateSH1(input: $input) {
      sh1Id
    }
  }
`);
